"use client"

import { usePathname } from "next/navigation"

const pageTitles: Record<string, string> = {
  "/stocks": "종목목록",
  "/conditions": "조건검색",
  "/portfolio": "포트폴리오",
  "/backtest": "관심종목",
  "/financials": "재무제표",
  "/trading": "자동매매",
}

function getPageTitle(pathname: string): string {
  for (const [prefix, title] of Object.entries(pageTitles)) {
    if (pathname === prefix || pathname.startsWith(prefix + "/")) return title
  }
  return "JaceStock"
}

export default function Header() {
  const pathname = usePathname()
  const title = getPageTitle(pathname)

  return (
    <header className="flex h-12 items-center border-b border-zinc-800 bg-zinc-950 px-4 md:h-14 md:px-6">
      <h1 className="text-sm font-semibold text-zinc-100">{title}</h1>
    </header>
  )
}
